import React from 'react';
import { Tool } from '../../types';
import './ToolCard.css';

interface ToolCardProps {
  tool: Tool;
  onClick: () => void;
}

const ToolCard: React.FC<ToolCardProps> = ({ tool, onClick }) => {
  return (
    <div className="tool-card" onClick={onClick}>
      <div className="tool-card-icon">
        {tool.icon}
      </div>
      <div className="tool-card-content">
        <h3 className="tool-card-title">{tool.name}</h3>
        <p className="tool-card-description">{tool.description}</p>
      </div>
      <div className="tool-card-footer">
        <button className="tool-card-button">Launch</button>
      </div>
    </div>
  );
};

export default ToolCard;
